<template>
  <div class="container">
    <p>
      <strong>Code Value: {{ codeValue }} </strong>
    </p>
    <div class="qr-container">
      <qrcode-vue :value="codeValue" :size="200" level="H"></qrcode-vue>
      <h4>QR Generator - Instructions</h4>
      <div class="row">
        <div class="col">
          <p>Add what you want to be changed to a QR</p>
          <p>Click "Generate" button</p>
          <p>
            Scan QR code below from your mobile device's native camera or in
            OneApp.
          </p>
          <p>Watch magic happen</p>
        </div>
        <div class="input-group mb-3">
          <label class="input-group-text">QR Value:</label>
          <input
            type="text"
            class="form-control"
            id="codeInput"
            v-model="codeInput"
            placeholder="edit me"
          />
        </div>
      </div>
    </div>
    <div class="py-3" style="text-align: center">
      <button class="ty-button" v-on:click="generate">Generate New Code</button>
    </div>
    <div v-if="scanResponse">
      <p>Scan Response:</p>
      <p>{{ scanResponse }}</p>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { analytics } from "../../config/firebaseInit";

export default {
  name: "QrDK",
  data: function () {
    return {
      codeInput: "",
      codeValue: "",
      scanResponse: null,
    };
  },
  props: {
    msg: String,
  },
  components: {
    QrcodeVue,
  },
  created() {
    analytics.logEvent("qr-dk");
  },
  methods: {
    generate: function () {
      this.codeValue = this.codeInput;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
body {
  font-family: ToyotaType-Regular;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.ty-button {
  background: #d92429;
  border-radius: 0px;
  width: 343px;
  height: 64px;
  font-family: ToyotaType-Semibold;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}

.qr-container {
  padding-top: 40px;
  text-align: center;
  height: 300px;
  /*background-color: #4281ff;*/
  height: 540px;
}
</style>
